import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('prescriptionSection');

    return {
        DETACH: t('detach'),
        ERROR_PARSE_FAILED: (message: string) => t('errorParseFailed', { message }),
        ERROR_SERVER_REJECTED: (message: string) => t('errorServerRejected', { message }),
        GAP_POLICY_BASE_RATE: t('gapPolicyBaseRate'),
        GAP_POLICY_LABEL: t('gapPolicyLabel'),
        GAP_POLICY_MASK: t('gapPolicyMask'),
        LEGEND_TITLE: t('legendTitle'),
        LEGEND_ZONE_MASK: t('legendZoneMask'),
        RATE_COLUMN_CONFIRM: t('rateColumnConfirm'),
        RATE_COLUMN_HINT: t('rateColumnHint'),
        RATE_COLUMN_LABEL: t('rateColumnLabel'),
        TITLE: t('title'),
        UPLOAD_HINT: t('uploadHint'),
        UPLOAD_PROCESSING: t('uploadProcessing'),
        WARNING_CANCEL: t('warningCancel'),
        WARNING_CONFIRM: t('warningConfirm'),
        WARNING_INVALID_POLYGONS: (count: number) => t('warningInvalidPolygons', { count }),
        WARNING_TITLE: t('warningTitle'),
        WARNING_UNSUPPORTED_CRS: (crs: string) => t('warningUnsupportedCrs', { crs }),
        ZONE_COUNT: (count: number) => t('zoneCount', { count })
    };
};

export default useTranslation;
